import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { Grid, Box, Paper, FormControlLabel, Checkbox, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormInput from '../form/form-input';
import { set } from 'lodash';

function FilterSection({ filterList, state, onChangeBulk }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{ padding: 2 }}>
            {/* Use Accordion on Mobile, Grid otherwise */}
            {isMobile ? (
                <Accordion defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="filter-content"
                        id="filter-header"
                    >
                        <Typography variant="h6">Filters</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            {filterList && filterList.map((filter, index) => (
                                <Grid item xs={12} key={index}>
                                    {filter.dataType === 'string' ? (
                                        <FormInput
                                            label={filter.label}
                                            onChange={(value, path) => {
                                                let data = {
                                                    page: 0,
                                                    filter: {
                                                        ...state.values.filter,
                                                    }
                                                };
                                                set(data, path, value);
                                                onChangeBulk(data);
                                            }}
                                            path={`filter.${filter.id}`}
                                            value={state.values.filter[filter.id]}
                                            fullWidth
                                        />
                                    ) : filter.dataType === 'boolean' ? (
                                        <FormControlLabel
                                            label={filter.label}
                                            control={
                                                <Checkbox
                                                    inputProps={{ 'aria-label': filter.label }}
                                                    checked={state.values.filter[filter.id]}
                                                    onChange={(event) => {
                                                        let data = {
                                                            page: 0,
                                                            filter: {
                                                                ...state.values.filter,
                                                            }
                                                        };
                                                        set(data, `filter.${filter.id}`, event.target.checked);
                                                        onChangeBulk(data);
                                                    }}
                                                />
                                            }
                                        />
                                    ) : null}
                                </Grid>
                            ))}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            ) : (
                <Paper elevation={2} sx={{ padding: 2 }}>
                    <Grid container spacing={2}>
                        {filterList && filterList.map((filter, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                {filter.dataType === 'string' ? (
                                    <FormInput
                                        label={filter.label}
                                        onChange={(value, path) => {
                                            let data = {
                                                page: 0,
                                                filter: {
                                                    ...state.values.filter,
                                                }
                                            };
                                            set(data, path, value);
                                            onChangeBulk(data);
                                        }}
                                        path={`filter.${filter.id}`}
                                        value={state.values.filter[filter.id]}
                                        fullWidth
                                    />
                                ) : filter.dataType === 'boolean' ? (
                                    <FormControlLabel
                                        label={filter.label}
                                        control={
                                            <Checkbox
                                                inputProps={{ 'aria-label': filter.label }}
                                                checked={state.values.filter[filter.id]}
                                                onChange={(event) => {
                                                    let data = {
                                                        page: 0,
                                                        filter: {
                                                            ...state.values.filter,
                                                        }
                                                    };
                                                    set(data, `filter.${filter.id}`, event.target.checked);
                                                    onChangeBulk(data);
                                                }}
                                            />
                                        }
                                    />
                                ) : null}
                            </Grid>
                        ))}
                    </Grid>
                </Paper>
            )}
        </Box>
    );
}

FilterSection.propTypes = {
    filterList: PropTypes.arrayOf(PropTypes.exact({
        id: PropTypes.string.isRequired,
        dataType: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        defaultValue: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool,
        ]),
    })).isRequired,
    state: PropTypes.object.isRequired,
    onChangeBulk: PropTypes.func.isRequired,
};

export default FilterSection;
